'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavbarController = function () {
  function NavbarController(authService, $state) {
    "ngInject";

    (0, _classCallCheck3.default)(this, NavbarController);
    this.authService = authService;
    this.$state = $state;
  }

  (0, _createClass3.default)(NavbarController, [{
    key: 'logOut',
    value: function logOut() {
      this.authService.logOut();
    }
  }, {
    key: 'checkCustomPermission',
    value: function checkCustomPermission(item) {
      if (item.name === 'Add Vehicle (Skupenet)') {
        return this.authService.hasEasierAd();
      }

      return true;
    }
  }]);
  return NavbarController;
}();

exports.default = NavbarController;


// WEBPACK FOOTER //
// ./client/app/common/navbar/navbar.controller.js